import AwardsSvg from '../common/svg/AwardsSvg';
import CustomerSvg from '../common/svg/CustomerSvg';
import ProjectSvg from '../common/svg/ProjectSvg';
import YearsSvg from '../common/svg/YearsSvg';

export const STATS_DATA = [
  {
    id: 1,
    icon: YearsSvg,
    value: 7,
    suffix: '+',
    title: 'Years',
    description: 'Working With Passion',
    delay: '300ms',
  },
  {
    id: 2,
    icon: CustomerSvg,
    value: 25,
    suffix: '+',
    title: 'Customer',
    description: 'Satisfied Customer',
    delay: '300ms',
  },
  {
    id: 3,
    icon: ProjectSvg,
    value: 40,
    suffix: '+',
    title: 'Project',
    description: 'We Have Completed',
    delay: '300ms',
  },
  // {
  //   id: 4,
  //   icon: AwardsSvg,
  //   value: 5,
  //   suffix: "",
  //   title: "Awards",
  //   description: "Achievement For Service",
  //   delay: "300ms",
  // },
];
